module.exports = __webpack_public_path__ + "img/defaultProduct.b54372fc.jpg";